import { convertADtoBS } from "../components/Calendar/functions/calendarFunctions";

export default function useFiscalYears({ count = 3 }: { count?: number } = {}): string[] {
  const currentBs = convertADtoBS(new Date());
  const currentBsYear = currentBs.bsYear;
  const currentBsMonth = currentBs.bsMonth;

  const baseYear = currentBsMonth <= 3 ? currentBsYear - 1 : currentBsYear;

  const fiscalYears: string[] = [];

  for (let i = 0; i < count; i += 1) {
    const startYear = baseYear - i;
    fiscalYears.push(`${startYear}/${startYear + 1}`);
  }

  return fiscalYears;
}
